import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EntityPickerComponent } from '@app/features/v3ndor/components/entity-picker/entity-picker.component';
import { FilterWidgetModule } from '@app/shared/components/filter-widget/filter-widget.module';
import { FormModule } from '@app/shared/components/form/form.module';
import { PaginatorModule } from '@app/shared/components/paginator/paginator.module';
import { SearchWidgetModule } from '@app/shared/components/search-widget/search-widget.module';
import { ResponsiveTableModule } from '@app/shared/components/table/responsive-table.module';
import {
  BadgeComponent,
  ButtonComponent,
  ModalComponent,
  SpinnerComponent,
  TooltipDirective,
} from '@teorema/patron';
// pTooltip do PrimeNG na grade (ver nota em manager.module.ts); o log usa o patron-tooltip.
import { TooltipModule } from 'primeng/tooltip';
import { BwUserLicensesComponent } from './bw-user-licenses.component';
import { CompanyGroupLicensesLogsComponent } from './company-group-licenses-logs.component';
import { CompanyGroupUserLicensesComponent } from './company-group-user-licenses.component';

/**
 * Chamado 0000577675 — grade de assentos e log de alterações, usados pelo detalhe do grupo empresa
 * (suporte), pela tela Acessos › Licenças de usuário (cliente) e pelo cadastro do usuário.
 */
@NgModule({
  declarations: [
    CompanyGroupUserLicensesComponent,
    CompanyGroupLicensesLogsComponent,
    BwUserLicensesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    FormModule,
    ResponsiveTableModule,
    FilterWidgetModule,
    PaginatorModule,
    SearchWidgetModule,
    BadgeComponent,
    ButtonComponent,
    ModalComponent,
    SpinnerComponent,
    TooltipDirective,
    TooltipModule,
    EntityPickerComponent,
  ],
  exports: [
    CompanyGroupUserLicensesComponent,
    CompanyGroupLicensesLogsComponent,
    BwUserLicensesComponent,
  ],
})
export class LicensesSharedModule {}
